---
title: "Early April Update"
date: "2026-04-02"
---

Improved selection, a rebuilt calendar, and a long list of improvements across the board.

---

## <IconHeading icon="MousePointerClick">Excel-Style Multi-Select</IconHeading>

Selecting entries on the tracked page now works like a spreadsheet. Click to select one, **Ctrl+click** (or **Cmd+click**) to toggle entries individually, and **Shift+click** to grab an entire range. You can even **Ctrl+Shift+click** to add a range on top of what you already have. Try it:

<MultiSelectDemo />

Once you've got your selection, export, delete, duplicate, or group — all actions apply to exactly the entries you picked.

---

## <IconHeading icon="Calendar">Calendar</IconHeading>

The [calendar](/calendar) got a fresh new look:

- See your exported and tracked hours on each day
- Filter between All, Tracked, or Exported views
- Click any week to jump straight to those entries
- Weekly totals column shows your hours at a glance
- Monthly summary strip with year-to-date above the calendar
- Jump to any month with the new month/year picker

---

## <IconHeading icon="Wrench">Bug Fixes & Stability</IconHeading>

- Fixed issues with matter prediction
- Countless other bug fixes across the application for a smoother day-to-day experience.
- General stability improvements.

---

That's it for early April. As always, [contact support](/support) if you have questions.
